import Api from '@/api';
import { Http } from '../../../utilities/util';

const loadOffers = (context, companyId) => new Promise((resolve, reject) => {
  Api.offerService.getOffers(companyId)
    .then(response => {
      context.commit('setBlueBoxOffers', response.data.payload);
      resolve(response.data);
    })
    .catch(() => {
      context.commit('setBlueBoxOffers', {});
      reject();
    });
});

const loadAdminOffers = (context, data) => new Promise((resolve, reject) => {
  Api.offerService.getAdminOffers(data)
    .then(response => {
      context.commit('setAdminOffers', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setAdminOffers', {});
      Http.setGlobalError(context, Http.createError(error, 'offers.actions.loadAdminOffers', { data }));
      reject();
    });
});

const loadPrivacyPolicy = () => new Promise(async (resolve, reject) => {
  try {
    const response = await Api.offerService.getPrivacyPolicy();
    resolve(response.data.payload);
  } catch (err) {
    reject(err);
  }
});

export default {
  loadOffers,
  loadAdminOffers,
  loadPrivacyPolicy,
};
